import { ArrowRight, Eye, Sparkles, Star, Users } from "lucide-react";
import { Avatar, PlatformIcon, type Platform } from "@/shared/ui";
import { fmtNum, fmtRub } from "@/shared/lib/format";
import type { Blogger } from "@/shared/api/wb";
import { cn } from "@/shared/lib/cn";

// Static categories from seed_data.EXPANSION_CATEGORIES — should come from API in real life.
const CATEGORIES = [
  { id: "similar-top", title: "Похожие на лучшие каналы", sub: "аудитория и формат как у сработавших", icon: Star,     blogger_ids: ["b14","b11","b10","b05"] },
  { id: "audience",    title: "Под вашу ЦА",              sub: "совпадение по портрету аудитории",       icon: Users,    blogger_ids: ["b13","b07","b12","b02"] },
  { id: "competitors", title: "Выбирают конкуренты",      sub: "каналы из похожих кампаний",              icon: Eye,      blogger_ids: ["b03","b08","b06","b01"] },
  { id: "new",         title: "Новые в категории",        sub: "недавно добавлены, ещё не разобраны",    icon: Sparkles, blogger_ids: ["b12","b03","b09","b15"] },
];

export function ExpansionRail({ bloggers, onAdd }: { bloggers: Map<string, Blogger>; onAdd: (id: string) => void }) {
  return (
    <div className="px-7 pb-12 pt-3">
      <div className="text-[11px] font-display font-semibold uppercase tracking-[0.16em] text-ink-40 mb-3">
        Расширяйте кампанию
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        {CATEGORIES.map((cat) => {
          const Icon = cat.icon;
          return (
            <div key={cat.id} className="bg-white rounded-md border border-ink-12 p-4">
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-start gap-2.5">
                  <div className="w-9 h-9 rounded-md bg-cream text-ink grid place-items-center flex-shrink-0">
                    <Icon size={16} />
                  </div>
                  <div>
                    <div className="font-display font-bold text-[15px]">{cat.title}</div>
                    <div className="text-[12px] text-ink-40 mt-0.5">{cat.sub}</div>
                  </div>
                </div>
                <button className="inline-flex items-center gap-1 text-[12.5px] text-link font-display font-semibold hover:underline whitespace-nowrap">
                  Все <ArrowRight size={12} />
                </button>
              </div>
              <div className="grid gap-1.5">
                {cat.blogger_ids.map((bid) => {
                  const b = bloggers.get(bid);
                  if (!b) return null;
                  return <ExpansionRow key={bid} b={b} onAdd={() => onAdd(bid)} />;
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function ExpansionRow({ b, onAdd }: { b: Blogger; onAdd: () => void }) {
  return (
    <div className="flex items-center gap-2.5 p-2 rounded-sm hover:bg-cream">
      <Avatar name={b.full} size={28} grad={b.grad as [string, string]} />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1 font-display font-semibold text-[13px] truncate">
          <PlatformIcon platform={b.platform as Platform} size={11} /> {b.name}
        </div>
        <div className="text-[11px] text-ink-40 font-mono">{fmtNum(b.reach)} · CPV {b.cpv}₽ · {fmtRub(b.price)}</div>
      </div>
      <button onClick={onAdd}
        className={cn("h-7 px-3 rounded-pill bg-ink text-white text-[11.5px] font-display font-semibold hover:bg-[#2A2A2A]")}>
        + Добавить
      </button>
    </div>
  );
}
